const dict = {
    underwritersInviteGroupTooltip:
        'Admins can invite new brokers. They can edit brokerage commissions and submissions as well as create other admins.',
    underwritersEditUserGroupTip:
        'Admins can invite new brokers. They can edit brokerage commissions and submissions as well as create other admins.',
    brokersInviteGroupTooltip:
        'Admins can invite new brokers to %brokerageName%. They can also edit brokerage commissions and submissions, as well as create other admins.',
    brokersEditUserGroupTip:
        'Admins can invite new brokers to %brokerageName%. They can also edit brokerage commissions and submissions, as well as create other admins.',
    brokersEditBrokerageChangeWarning:
        "This broker's existing submissions won't be moved. You'll still be able to find their prior submissions at %brokerageName%.",
    brokersInviteChangeInfo: '',
    brokersInviteChangeWarning:
        "This broker's existing submissions won't be moved. You'll still be able to find their prior submissions at %existingBrokerage%."
};

export function lang(key, params = {}) {
    return Object.keys(params).reduce((prev, curr) => {
        return prev.replace(new RegExp('%' + curr + '%', 'g'), params[curr]);
    }, dict[key]);
}

export function clean(str) {
    const undot = str => {
        if (str.charAt(str.length - 1) === '.') {
            return str.substring(0, str.length - 1);
        }
        return str;
    };
    return undot(str.trim());
}
